




















import { defineComponent, ref } from '@vue/composition-api';
import Preview from '../preview/index.vue';
import PreviewDialog from '../preview-dialog/index.vue';

const name = 'ttam-instant-page-editor';
export default defineComponent({
  components: {
    Preview,
    PreviewDialog,
  },
  props: {
    previewUrl: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    previewClickKey: {
      type: String,
      default: '',
    },
    previewShowKey: {
      type: String,
      default: '',
    },
  },
  setup() {
    const dialogVisible = ref(false);
    const onClick = () => {
      dialogVisible.value = true;
    };
    return {
      name,
      dialogVisible,
      onClick,
    };
  },
});
